"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFeasibleZone = exports.getFeasibleAreaFallback = exports.getFeasible_Zone = exports.getSetbacks = exports.convertMultipolygonToPolygon = void 0;
// @ts-ignore
const arcgis_to_geojson_utils_1 = require("@esri/arcgis-to-geojson-utils");
const turf = __importStar(require("@turf/turf"));
const streets_1 = require("./streets");
const core_1 = require("@natomas-org/core");
const general_1 = require("./general");
// Converts multiPolygons to polygons and multiLines to lines (needed for turf.difference)
const convertMultipolygonToPolygon = (feature) => (0, arcgis_to_geojson_utils_1.arcgisToGeoJSON)((0, arcgis_to_geojson_utils_1.geojsonToArcGIS)(feature));
exports.convertMultipolygonToPolygon = convertMultipolygonToPolygon;
function getSetbacks(streetCoordinates, nonAduStructures, parcelData, setbacksInFeet) {
    let feasibleZone = null;
    if (!streetCoordinates ||
        !(streetCoordinates === null || streetCoordinates === void 0 ? void 0 : streetCoordinates.lng) ||
        !(streetCoordinates === null || streetCoordinates === void 0 ? void 0 : streetCoordinates.lat) ||
        !parcelData) {
        return null;
    }
    const streetVsNeighboringLines = (0, streets_1.getStreetVsNeighboringLines)(streetCoordinates, turf.feature(parcelData));
    feasibleZone = parcelData;
    if (streetVsNeighboringLines) {
        const { parcelLinesNextToNeighbors, streetSideLines } = streetVsNeighboringLines;
        if (parcelLinesNextToNeighbors && streetSideLines) {
            feasibleZone = getFeasible_Zone(parcelData, parcelLinesNextToNeighbors, streetSideLines, setbacksInFeet);
        }
    }
    try {
        if (nonAduStructures.length > 0) {
            feasibleZone = turf.difference(
            // @ts-ignore
            feasibleZone, turf.buffer(nonAduStructures[0], setbacksInFeet.primary, {
                units: "feet",
            }));
        }
    }
    catch (e) {
        console.log(e);
        console.error("error computing setbacks from primary structure");
    }
    return feasibleZone;
}
exports.getSetbacks = getSetbacks;
function getFeasibleZoneWithFrontYardSetback(parcelBoundary, parcelLinesNextToNeighbors, streetSideLines, setbacksInFeet) {
    let parcel = (0, exports.convertMultipolygonToPolygon)(parcelBoundary);
    const parcelSides = [];
    const lotLines = { parcelLinesNextToNeighbors, streetSideLines };
    // eslint-disable-next-line guard-for-in
    for (const lineType in lotLines) {
        if (lineType === "parcelLinesNextToNeighbors") {
            for (const nbLine of lotLines["parcelLinesNextToNeighbors"]) {
                parcelSides.push(turf.buffer(nbLine, setbacksInFeet.sideAndRear, { units: "feet" }));
            }
        }
        if (lineType === "streetSideLines") {
            for (const streetLine of lotLines["streetSideLines"]) {
                parcelSides.push(turf.buffer(streetLine, setbacksInFeet.front, { units: "feet" }));
            }
        }
    }
    for (const parcelSide of parcelSides) {
        parcel = turf.difference(parcel, parcelSide);
    }
    return parcel;
}
function getFeasible_Zone(parcelBoundary, parcelLinesNextToNeighbors, streetSideLines, setbacksInFeet) {
    try {
        return getFeasibleZoneWithFrontYardSetback(parcelBoundary, parcelLinesNextToNeighbors, streetSideLines, setbacksInFeet);
    }
    catch (e) {
        console.error("getFeasibleZone error ", e);
        return getFeasibleAreaFallback(parcelBoundary);
    }
}
exports.getFeasible_Zone = getFeasible_Zone;
// eslint-disable-next-line valid-jsdoc
/** Computes setbacks on property boundary
 * @params parcel geometry
 * @return buffered property boundary
 */
function getFeasibleAreaFallback(propertyGeometry) {
    let feasibleArea = (0, exports.convertMultipolygonToPolygon)(propertyGeometry);
    const yards = [];
    const lotLine = turf.polygonToLine(propertyGeometry);
    const setback = 4;
    yards.push(turf.buffer(lotLine, setback, { units: "feet" }));
    for (const yard of yards) {
        feasibleArea = turf.difference(feasibleArea, yard);
    }
    return feasibleArea;
}
exports.getFeasibleAreaFallback = getFeasibleAreaFallback;
const getFeasibleZone = (parcelSearchData, jurisdictionData) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const frontSetback = (_b = (_a = jurisdictionData === null || jurisdictionData === void 0 ? void 0 : jurisdictionData.placementConstraints) === null || _a === void 0 ? void 0 : _a.frontSetback) !== null && _b !== void 0 ? _b : (_c = core_1.DEFAULT_JURISDICTION_DATA === null || core_1.DEFAULT_JURISDICTION_DATA === void 0 ? void 0 : core_1.DEFAULT_JURISDICTION_DATA.placementConstraints) === null || _c === void 0 ? void 0 : _c.frontSetback;
    const sideAndRear = (_e = (_d = jurisdictionData === null || jurisdictionData === void 0 ? void 0 : jurisdictionData.placementConstraints) === null || _d === void 0 ? void 0 : _d.sideAndRearSetBacks) !== null && _e !== void 0 ? _e : (_f = core_1.DEFAULT_JURISDICTION_DATA === null || core_1.DEFAULT_JURISDICTION_DATA === void 0 ? void 0 : core_1.DEFAULT_JURISDICTION_DATA.placementConstraints) === null || _f === void 0 ? void 0 : _f.sideAndRearSetBacks;
    const primarySetback = (_h = (_g = jurisdictionData === null || jurisdictionData === void 0 ? void 0 : jurisdictionData.placementConstraints) === null || _g === void 0 ? void 0 : _g.primarySetBacks) !== null && _h !== void 0 ? _h : (_j = core_1.DEFAULT_JURISDICTION_DATA === null || core_1.DEFAULT_JURISDICTION_DATA === void 0 ? void 0 : core_1.DEFAULT_JURISDICTION_DATA.placementConstraints) === null || _j === void 0 ? void 0 : _j.primarySetBacks;
    if (!parcelSearchData ||
        !(parcelSearchData === null || parcelSearchData === void 0 ? void 0 : parcelSearchData.parcelGeometry) ||
        !(parcelSearchData === null || parcelSearchData === void 0 ? void 0 : parcelSearchData.streetCoordinates)) {
        return null;
    }
    const searchData = (0, general_1.convertSearchPayloadFromDBFormat)(parcelSearchData);
    const streetCoordinates = parcelSearchData === null || parcelSearchData === void 0 ? void 0 : parcelSearchData.streetCoordinates;
    if (!searchData || !streetCoordinates) {
        return null;
    }
    const { parcelGeometry, buildingsGeometry } = searchData;
    const result = [];
    buildingsGeometry.forEach((building) => {
        result.push((0, exports.convertMultipolygonToPolygon)(building));
    });
    result.sort((a, b) => turf.area(b) - turf.area(a));
    return getSetbacks(streetCoordinates, result, parcelGeometry, {
        front: frontSetback,
        sideAndRear: sideAndRear,
        primary: primarySetback,
    });
};
exports.getFeasibleZone = getFeasibleZone;
//# sourceMappingURL=geometry.js.map